// ********************** CART **************************** \\
const showCart = () => {
  console.log("show cart");
  const cart = document.querySelector(".cart");
  cart.classList.add("show-cart");
  cart.setAttribute("aria-hidden", false);
  disableScroll();
};

const hideCart = () => {
  console.log("hide cart");
  const cart = document.querySelector(".cart");
  cart.classList.remove("show-cart");
  cart.setAttribute("aria-hidden", true);
  enableScroll();
};

document.addEventListener("liquid-ajax-cart:request-end", (event) => {
  const { requestState } = event.detail;

  // If the "add to cart" request is successful
  if (requestState.requestType === "add" && requestState.responseData?.ok) {
    // Add the CSS class to the "body" tag
    showCart();
  }
});

const runWhenInit = () => liquidAjaxCart.conf("quantityTagAllowZero", true);

document.addEventListener("DOMContentLoaded", () => {
  document.querySelector("#cart-btn").addEventListener("click", showCart);

  if (window.liquidAjaxCart?.init) {
    // if Liquid Ajax Cart is already initialized
    runWhenInit();
  } else {
    // wait for Liquid Ajax Cart to be initialized
    document.addEventListener("liquid-ajax-cart:init", runWhenInit);
  }
});

// ********************** END CART **************************** \\
